import { type CommonAction, success } from "@iflyrpa/share";
import { z } from "zod";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export const UnreadCountSchema = z.object({
    connections: z.number().nullable(),
    mentions: z.number().nullable(),
    unread_count: z.number().nullable(),
    likes: z.number().nullable(),
});

export type UnreadCount = z.infer<typeof UnreadCountSchema>;

export type PublishAction = CommonAction<ActiomCommonParams, UnreadCount>;

export const getXhsUnreadCount: PublishAction = async (_task, params) => {
    if (DisabledReq) return success({ connections: 0, mentions: 0, unread_count: 0, likes: 0 }, "获取未读消息数成功");
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com",
    };
    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);

    let unreadCount: UnreadCount = {
        connections: null,
        mentions: null,
        unread_count: null,
        likes: null,
    };

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: unreadCount };

    const apiPath = "/api/sns/web/unread_count";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const requestData = {};
    const xsHeader = xsEncrypt.signHeadersPost(apiPath, recordCookie, "xhs-pc-web", requestData);

    const res = await http.api<{ code: number; msg: string; data: UnreadCount }>(
        {
            method: "GET",
            url: "https://edith.xiaohongshu.com/api/sns/web/unread_count",
            data: requestData,
            headers: xsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    if (isSuccess) unreadCount = res.data;
    const message = `获取未读消息数${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;

    // return response(isSuccess ? 0 : 414, message, unreadCount);
    return success(unreadCount, message);
};
